import React, { useState, useEffect } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { SignedIn, SignedOut, UserButton, SignIn, useUser } from "@clerk/clerk-react";
import { HelpCircle, Dog, Menu, PawPrint, Stethoscope, MessageCircle, Phone } from "lucide-react";
import { Button } from "./ui/button";
import CheckoutButton from './CheckoutButton';
import { UpgradeButton } from '../pages/UpgradeButton';
import { Sidebar } from "@/components/sidebar";
import { Sheet, SheetContent, SheetTrigger } from "@/components/ui/sheet"
import { useAnalysis } from '../AnalysisContext';
import UpgradeModalVetConsult from '../pages/UpgradeModalVetConsult';
import { cn } from "@/lib/utils";
import { getUserPlan } from '@/utils/plans';

const Header = () => {
  const [showSignIn, setShowSignIn] = useState(false);
  const [searchParams, setSearchParams] = useSearchParams();
  const { user, isLoaded, isSignedIn } = useUser();
  const navigate = useNavigate();
 

  useEffect(() => {
    if (searchParams.get("sign-in") === "true") setShowSignIn(true);
    else setShowSignIn(false);
  }, [searchParams]);

  useEffect(() => {
    if (isLoaded && isSignedIn) navigate("/dog-analyzer", { replace: true });
  }, [isLoaded, isSignedIn]);

  return (
    <header className="sticky top-0 z-50 w-full border-b bg-gradient-to-r from-amber-300 via-amber-400 to-orange-400">
      <div className="flex h-14 sm:h-16 items-center px-3 sm:px-4">
        <Link to="/" className="flex items-center gap-2">
          <div className="relative">
            <Dog className="h-8 w-8 sm:h-7 sm:w-7 text-amber-900 transition-transform hover:rotate-12" />
            <div className="absolute -bottom-1 -right-1 h-2.5 w-2.5 bg-green-400 rounded-full border-2 border-white" />
          </div>
          <div className="hidden sm:block">
            <h1 className="text-xl font-bold text-amber-900">DogScan AI</h1>
            <p className="text-xs text-amber-800/80">Análisis AI + Veterinarios 24/7</p>
          </div>
        </Link>
        <div className="ml-auto flex items-center gap-1.5 sm:gap-2">
          <SignedOut>
            <Button
              variant="secondary"
              size="sm"
              onClick={() => setSearchParams({ "sign-in": "true" })}
              className="bg-amber-900 text-amber-100 hover:bg-amber-800"
            >
              Iniciar Sesión
            </Button>
          </SignedOut>
        </div>
      </div>

      {showSignIn && (
        <div
          className="fixed inset-0 flex items-center justify-center bg-black/50 z-50"
          onClick={(e) => {
            if (e.target === e.currentTarget) {
              setShowSignIn(false);
              setSearchParams({});
            }
          }}
        >
          <SignIn
            appearance={{
              elements: {
                card: "bg-white shadow-xl rounded-xl",
                headerTitle: "text-amber-900",
                headerSubtitle: "text-amber-700",
                formButtonPrimary: "bg-amber-600 hover:bg-amber-700",
                formFieldInput: "border-amber-200 focus:border-amber-500 focus:ring-amber-500",
                footerActionLink: "text-amber-600 hover:text-amber-700"
              }
            }}
          />
        </div>
      )}
    </header>
  );
};

export default Header;